import { preload } from 'swr';
import fetcher from 'Helpers/fetcher';

const usePreloadFetch = (endpoints: string[]) => {
  endpoints.forEach((endpoint) => preload(endpoint, fetcher));
};

export default usePreloadFetch;
